import i18n from '@i18n';
import { CellText, CellStatus } from 'components/ColumnsCells';
import { VEHICLE_STATUS_FIELDS as FIELDS } from '@vehicles/common/constants';
import { CellStatusCircleIndicator } from '../../../../components/ColumnsCells';

export const columns = [
  {
    label: i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TABLE__USER'),
    field: FIELDS.USER,
    align: 'left',
    renderer: CellText,
  },
  {
    label: i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TABLE__STATUS_DATE'),
    field: FIELDS.STATUS_DATE,
    align: 'left',
    renderer: CellText,
  },
  {
    label: i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TABLE__ESTATUS'),
    field: FIELDS.STATUS,
    align: 'left',
    renderer: CellText,
  },
  {
    label: i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TABLE__ACTIVE'),
    field: FIELDS.ACTIVE,
    align: 'center',
    renderer: CellStatusCircleIndicator
  },
  // {
  //   label: i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TABLE__REASON'),
  //   field: FIELDS.REASON,
  //   align: 'left',
  //   renderer: CellText,
  // },
];
